export const RUNNING = 2

export const DELETED = 8

export const WAITING_DELETION = 16

export const ALL_VALID_STATUSES = [5, 10, 2, 11, 18, 12, 13, 20]

// Status em que o contrato deixa de ser mutável pela tela (exclusão e aprovação de
// exclusão).
export const NON_MUTABLE_STATUSES = [DELETED, WAITING_DELETION]

export const REFUSED = 14

export const CANCELED_AFTER_RUNNING = 13

/**
 * Desfechos que a aprovação de uma solicitação de exclusão pode aplicar.
 *
 * Todos preservam registro, histórico, pagamentos e comissões: a aprovação marca o
 * contrato com proteção contra exclusão permanente, inclusive quando o desfecho é
 * Deletado (8).
 *
 * ⚠️ "Cancelado após rodando" (13) está dentro de ALL_VALID_STATUSES: o contrato CONTINUA
 * contando no Faturômetro e nas Medalhas. É correto — a venda aconteceu —, mas é diferente
 * de 8 e 14, que saem dos indicadores. Por isso cada opção carrega a sua consequência.
 */
export const DELETION_OUTCOMES = [
  {
    value: DELETED,
    label: 'Deletado',
    hint: 'Contrato que não deveria existir (duplicado, erro de cadastro ou de importação). Sai dos indicadores e fica preservado na base.',
    keepsIndicators: false,
  },
  {
    value: REFUSED,
    label: 'Recusado',
    hint: 'O cliente ou o parceiro recusou. Sai dos indicadores.',
    keepsIndicators: false,
  },
  {
    value: CANCELED_AFTER_RUNNING,
    label: 'Cancelado após rodando',
    hint: 'Distrato depois de o contrato ter valido. CONTINUA contando no Faturômetro e nas Medalhas.',
    keepsIndicators: true,
  },
]

export const DEFAULT_DELETION_OUTCOME = DELETED
